import { useOktaAuth } from '@okta/okta-react';

export function useIsEditor() {
  const { authState } = useOktaAuth();
  if (!authState?.isAuthenticated) return false;
  const roles = authState?.accessToken?.claims?.roles ?? [];
  return Array.isArray(roles) && roles.includes('orion_fu_editor');
}
